import React from "react";

import ScaffoldLogo from "../../assets/images/logo/SCAFFOLD.svg";
import DefaultAvatar from "../../assets/images/default-avatar.svg";
import DownBlackArrow from "../../assets/images/Enquiry/down-black-arrow.svg";

function NavBar(props) {

    return (
        <div className="navbar navbar-expand-md mb-2">
            <div className="container-fluid" id="navbar-warapper">
                <div className="navbar-left-header">
                    <div id="cmp-logo">
                        <i id="sidemenu-btn" className="ti ti-menu-2 cursor-pointer f-24"></i>
                        <a className="navbar-brand-logo" href="#"><img src={ScaffoldLogo}
                            className="img-fluid" /></a>
                    </div>
                    <div className="vr vertical-seperator ml-2 mr-4"></div>
                    <div id="crnt-page" className="fw-700 f-16 c-lightgray">
                        Shop Floor Digitalization
                    </div>
                    <div className="vr vertical-seperator ml-3 mr-3"></div>
                    <div id="crnt-page" className="fw-700 f-16 c-darkgray">
                        {props.title}
                    </div>
                </div>
                <div className="navbar-right-header">
                    <div className="nav-item my-auto dropdown-menu-li" hidden>
                        <a id="notifcationLink" role="button" className="nav-link mr-2 f-12 fw-500 c-blue"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <div className="notifier new">
                                <i className="bell">
                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M22.5755 19.3264C21.9059 18.7294 21.3196 18.045 20.8325 17.2917C20.3007 16.2518 19.9819 15.1161 19.895 13.9514V10.5208C19.8996 8.69139 19.236 6.92324 18.0288 5.54859C16.8217 4.17393 15.1541 3.2874 13.3394 3.05555V2.15972C13.3394 1.91384 13.2417 1.67803 13.0679 1.50417C12.894 1.33031 12.6582 1.23264 12.4123 1.23264C12.1664 1.23264 11.9306 1.33031 11.7568 1.50417C11.5829 1.67803 11.4852 1.91384 11.4852 2.15972V3.06944C9.68681 3.318 8.03939 4.2099 6.84811 5.57993C5.65683 6.94997 5.00242 8.70531 5.00608 10.5208V13.9514C4.9191 15.1161 4.60037 16.2518 4.06858 17.2917C3.59002 18.0433 3.01316 18.7276 2.3533 19.3264C2.27922 19.3915 2.21986 19.4716 2.17914 19.5614C2.13843 19.6512 2.11731 19.7486 2.11719 19.8472V20.7917C2.11719 20.9758 2.19035 21.1525 2.32059 21.2827C2.45082 21.4129 2.62745 21.4861 2.81163 21.4861H22.1172C22.3014 21.4861 22.478 21.4129 22.6082 21.2827C22.7385 21.1525 22.8116 20.9758 22.8116 20.7917V19.8472C22.8115 19.7486 22.7904 19.6512 22.7497 19.5614C22.709 19.4716 22.6496 19.3915 22.5755 19.3264ZM3.56163 20.0972C4.20775 19.4731 4.77663 18.7736 5.25608 18.0139C5.92595 16.758 6.31679 15.3722 6.40191 13.9514V10.5208C6.37437 9.70697 6.51088 8.89588 6.80333 8.13588C7.09578 7.37587 7.53817 6.68249 8.10417 6.09701C8.67016 5.51154 9.34819 5.04595 10.0979 4.72796C10.8475 4.40998 11.6536 4.24611 12.4679 4.24611C13.2822 4.24611 14.0882 4.40998 14.8379 4.72796C15.5876 5.04595 16.2656 5.51154 16.8316 6.09701C17.3976 6.68249 17.84 7.37587 18.1324 8.13588C18.4249 8.89588 18.5614 9.70697 18.5339 10.5208V13.9514C18.619 15.3722 19.0098 16.758 19.6797 18.0139C20.1591 18.7736 20.728 19.4731 21.3741 20.0972H3.56163Z"
                                            fill="black" />
                                        <path
                                            d="M12.5008 23.8056C12.9382 23.7955 13.358 23.631 13.6859 23.3413C14.0138 23.0515 14.2286 22.6551 14.2924 22.2222H10.6396C10.7053 22.6669 10.9302 23.0726 11.2725 23.3638C11.6148 23.6551 12.0513 23.8121 12.5008 23.8056V23.8056Z"
                                            fill="black" />
                                    </svg>
                                </i>
                            </div>
                        </a>
                        <div className="dropdown-menu notification-list" aria-labelledby="notificationLink">
                            <div className="row px-3 py-2">
                                <div className="col-8">
                                    <span className="fw-500 f-16">Notifications</span>
                                </div>
                                <div className="col-4">
                                    <a href="/Notification/All" className="float-right fw-500">See All</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="vr vertical-seperator ml-3 mr-2"></div>

                    <div className="nav-item my-auto dropdown-menu-li">
                        <a href="#" role="button" id="dropdownMenuLink"
                            className="d-flex align-items-center ml-3" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <div className="user-name d-flex flex-column">
                                <div className="c-blue fw-700 f-14 text-capitalize">
                                    Stewart K
                                </div>
                                <div className="fw-500 f-12 c-black text-capitalize">
                                    Production Planner
                                </div>
                            </div>
                            <div className="u-icon">
                                <img src={DefaultAvatar} className="img-fluid user-icon" />
                            </div>
                            <img src={DownBlackArrow} className="img-fluid" />
                        </a>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <ul style={{ marginBottom: "0rem" }}>
                                <li className="dropdown-item" hidden>
                                    <div>
                                        <a href="/User/Profile"><img src="/img/my-profile.svg"
                                            alt="Profile" /><span className="c-black">My Profile</span></a>
                                    </div>
                                </li>
                                <li className="dropdown-item">
                                    <div>
                                        <a className="d-flex align-items-center" href="/Logout"><i
                                            className="c-black f-18 ti ti-logout"></i><span className="c-black">Log
                                                out</span></a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NavBar;